<ng-container *ngIf="card">
    <span>
        <h6 *ngIf="card.aliasNo === favorite">
        <span class="homeCardUsageDetail">{{ 'HOME_SLIDER_CARD_LASTUSAGE_DETAIL_LABEL' | translate }} {{card.usage[0].date}}<br />
            {{ 'HOME_SLIDER_CARD_LASTCHARGE_DETAIL_LABEL' | translate }} {{card.usage[1].date}} 
        </span>
        <span class="homeCardBalance">
            {{ card.balance }} {{ apiSettings.city.currency }}
        </span>
        </h6>
    </span>
</ng-container>